import {DialogContent, DialogTitle, Grid, TextField} from "@mui/material";
import {Dialog2} from "../../../../misc/Dialog2";
import {SmoothActionBar} from "../../../../misc/SmoothActionBar";
import {MiscProduct} from "../../../../api/MiscProducts";
import {useEffect, useState} from "react";
import {useAsyncAction} from "nate-react-api-helpers";
import {useSyncedRef} from "../../../../misc/SyncedRef";
import {Product, ProductScript} from "../../../../api/Products";
import {DimensionInput2} from "../../../manufacturing/DimensionInput2";
import {handingOptions} from "../../quote/openings/QuoteOpenings";
import {dummySelectWrapper} from "../../../../misc/scroller/Table";
import {SelectFiltered} from "../../../manufacturing/SelectFiltered";
import {ManualScriptInput} from "../../../../api/ProjectFreeformChange";

export function ManualDimension<T = (MiscProduct | Product)>(props: {
    value: T;
    scripts: ProductScript[];
    onDone(input: T, extra: {
        handing?: string;
        scriptInputs: ManualScriptInput[];
    }): Promise<void>;
    onCancel(): void;
}) {
    const [length, setLength] = useState("");
    const [width, setWidth] = useState("");
    const [height, setHeight] = useState("");
    const [handing, setHanding] = useState("");

    const [scriptValues, setScriptValues] = useState<ManualScriptInput[]>([]);

    useEffect(() => {
        setScriptValues(props.scripts.map(s => ({
            name: s.name,
            value: "",
        })))
    }, [props.scripts])

    const onDoneRef = useSyncedRef(props.onDone);
    const callback = useAsyncAction(async input => {
        await onDoneRef.current(input.value, input.extra);
    }, []);

    const val = props.value as any;

    const submit = () => {
        callback.callback({
            value: Object.assign({}, props.value, {
                dimLength: length,
                dimWidth: width,
                dimHeight: height,
            }),
            extra: {
                handing: handing === "" ? undefined : handing,
                scriptInputs: scriptValues,
            }
        });
    };

    return (
        <Dialog2 open onClose={props.onCancel} onEnterPress={submit}>
            <DialogTitle>
                Manual Dimensions
            </DialogTitle>
            <DialogContent>
                <div style={{height: 8}} />
                <Grid container spacing={1} direction="column">
                    {val.dimLengthFormula &&
                        <Grid item><DimensionInput2 label="Length" value={length} onChange={e => setLength(e)} /></Grid>}
                    {val.dimWidthFormula &&
                        <Grid item><DimensionInput2 label="Width" value={width} onChange={e => setWidth(e)} /></Grid>}
                    {val.dimHeightFormula &&
                        <Grid item><DimensionInput2 label="Height" value={height} onChange={e => setHeight(e)} /></Grid>}
                    <Grid item>
                        <SelectFiltered
                            label="Handing (if applicable)" value={handing} onChange={setHanding}
                            options={handingOptions(dummySelectWrapper({openingType: "Single"}))}/>
                    </Grid>
                    {scriptValues.map((v, i) => (
                        <Grid item key={i}>
                            <TextField label={"Script " + v.name} value={v.value} onChange={e => {
                                const newValues = [...scriptValues];
                                newValues[i].value = e.target.value;
                                setScriptValues(newValues);
                            }} />
                        </Grid>
                    ))}
                </Grid>
            </DialogContent>
            <SmoothActionBar
                loading={callback.loading}
                error={callback.error}
                actionName="Ok"
                onCancel={props.onCancel}
                onSubmit={submit}
            />
        </Dialog2>
    )
}